import React from "react";

const Verification = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            fillRule="evenodd"
            d="M9.833 5.2c-.427 0-.837.169-1.139.469-.302.3-.472.707-.472 1.131v22.4c0 .424.17.831.472 1.131.302.3.712.469 1.14.469h16.11c.428 0 .838-.169 1.14-.469.302-.3.472-.707.472-1.131v-16h-4.834a3.233 3.233 0 0 1-2.278-.937A3.189 3.189 0 0 1 19.5 10V5.2H9.833Zm12.89 2.263L25.276 10h-2.555V7.463ZM6.415 3.406A4.85 4.85 0 0 1 9.833 2h11.278c.427 0 .837.169 1.14.469l8.055 8c.302.3.472.707.472 1.131v17.6c0 1.273-.51 2.494-1.416 3.394A4.85 4.85 0 0 1 25.944 34H9.834a4.85 4.85 0 0 1-3.418-1.406A4.783 4.783 0 0 1 5 29.2V6.8c0-1.273.51-2.494 1.416-3.394ZM23.86 18.469c.63.624.63 1.637 0 2.262l-6.444 6.4a1.617 1.617 0 0 1-2.278 0l-3.223-3.2a1.592 1.592 0 0 1 0-2.262 1.62 1.62 0 0 1 2.279 0l2.083 2.068 5.305-5.268a1.62 1.62 0 0 1 2.279 0Z"
            clipRule="evenodd"
            className='u_fill'
        />
    </svg>
);

export default Verification;